var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileSvg01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 15.75H7.4998L7.08655 13.89C6.59474 13.6977 6.1348 13.4322 5.7223 13.1025L3.9043 13.6747L2.4043 11.0768L3.8083 9.78825C3.72972 9.26619 3.72972 8.73531 3.8083 8.21325L2.4043 6.924L3.9043 4.326L5.7223 4.89825C6.13498 4.56823 6.59518 4.30248 7.0873 4.11L7.4998 2.25H10.4998L10.913 4.11C11.4049 4.30231 11.8648 4.56781 12.2773 4.8975L14.0953 4.32525L15.5953 6.92325L14.1913 8.21175C14.2699 8.73381 14.2699 9.26469 14.1913 9.78675L15.5953 11.0753L14.0953 13.6733L12.2773 13.101C11.8649 13.4312 11.405 13.6972 10.913 13.89L10.4998 15.75Z",
    stroke: "#182EA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z",
    stroke: "#182EA6",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSvg01);
export default __webpack_public_path__ + "static/media/profile-svg01.726944dacdf32d1653216d5b5ebd407a.svg";
export { ForwardRef as ReactComponent };